<template>
  <div>
    <el-form inline size="small">
      <el-form-item>
        <el-button type="danger" size="small" @click="handleSettlement"
          >成绩结算</el-button
        >
      </el-form-item>
      <el-form-item label="老师占比:">
        <span>百分之 </span>
        <el-input-number
          v-model="params.teacherRadio"
          :min="0"
          :max="100"
          size="small"
          :controls="false"
          style="width: 80px"
        />
      </el-form-item>
      <!-- <el-form-item label="企业导师评分占比">
        <el-input-number
          v-model="params.enterpriseRadio"
          :min="0"
          :max="100"
          size="small"
        />
        <span style="margin-right: 20px"> %</span>
      </el-form-item> -->
      <el-form-item label="学生占比:">
        <span>百分之 </span>
        <el-input-number
          v-model="params.studentRadio"
          :min="0"
          :max="100"
          size="small"
          :controls="false"
          style="width: 80px"
        />
      </el-form-item>
    </el-form>

    <el-table class="list" :data="list">
      <el-table-column label="团队" prop="teamName"> </el-table-column>
      <el-table-column
        label="姓名"
        prop="captainName"
        align="center"
        width="80"
      >
      </el-table-column>
      <el-table-column label="得分" prop="score" align="center" width="60">
      </el-table-column>
      <el-table-column label="评分" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="danger" @click="handelGrade(row.teamId)"
            >评</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-drawer
      :visible.sync="show"
      size="70%"
      direction="btt"
      :withHeader="false"
    >
      <div class="content" style="padding: 50px 20px 0">
        <div class="top-row">
          <span>{{ itemInfo.teamName }}</span>
          <span v-if="itemInfo.score || itemInfo.score == 0"
            >总分：<span style="color: #f56c6c; font-size: 24px">{{
              itemInfo.score
            }}</span></span
          >
        </div>

        <el-table
          class="list score-list"
          :data="scoreItemList"
          :span-method="objectSpanMethod"
          style="width: 100%"
        >
          <el-table-column
            prop="postName"
            label="职位"
            width="100"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="title"
            label="项目细则"
            width="165"
            align="center"
          >
          </el-table-column> -->
          <el-table-column prop="info" label="条目" align="center">
          </el-table-column>
          <el-table-column prop="score" label="满分" width="55" align="center">
          </el-table-column>
          <el-table-column label="学生评分" width="80" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.systemComplete">{{
                scope.row.result
              }}</span>
              <span v-else>{{ scope.row.studentScore }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="teacherScore"
            label="教师评分"
            width="170"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="!scope.row.systemComplete"
                v-model="scope.row.teacherScore"
                :min="0"
                :max="scope.row.score"
                :precision="1"
                size="small"
                :controls="false"
              />
              <span v-else>——</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="enterpriseScore"
            label="企业导师评分"
            width="170"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="!scope.row.systemComplete"
                v-model="scope.row.enterpriseScore"
                :min="0"
                :max="scope.row.score"
                :precision="1"
                size="small"
              />
              <span v-else>本项分数系统自动计算</span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="itemScore"
            label="得分"
            width="80"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="dialog-footer" style="margin-top: 20px; text-align: center">
        <el-button size="small" @click="show = false">取 消</el-button>
        <el-button type="danger" size="small" @click="handleSubmit"
          >评</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getGradeTeamList,
  getGradeInfo,
  giveGrade,
  setGrade,
  scoreWeight,
  editScoreWeight,
} from "@/api/teamGrade";
export default {
  data() {
    return {
      list: [],
      teamId: null,
      itemInfo: {},
      show: false,
      idArr: [],
      idPos: 0,
      totalScore: 0,
      params: {
        classChapterId: this.$route.query.classChapterId,
        enterpriseRadio: 20,
        teacherRadio: 50,
        studentRadio: 30,
      },
    };
  },
  created() {
    this.getList();
    this.getWeight();
  },
  computed: {
    scoreItemList() {
      if (this.itemInfo.itemScoreList) return this.itemInfo.itemScoreList;
    },
    scoreRate() {
      return (
        this.params.enterpriseRadio +
        this.params.teacherRadio +
        this.params.studentRadio
      );
    },
  },
  methods: {
    getWeight() {
      scoreWeight({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.params = { ...this.params, ...res.data };
        }
      });
    },
    saveWeight() {
      this.params.classId = this.$route.query.id;
      editScoreWeight(this.params).then((res) => {});
    },
    getList() {
      getGradeTeamList({
        classChapterId: this.$route.query.classChapterId,
      }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    async handelGrade(teamId) {
      this.teamId = teamId;
      let res = await getGradeInfo({
        classChapterId: this.$route.query.classChapterId,
        teamId,
      });
      if (res.code == 0) {
        this.itemInfo = res.data;
        if (!this.itemInfo.score && this.itemInfo.score != 0)
          this.itemInfo.itemScoreList.forEach((item) => {
            item.teacherScore = item.score;
            item.enterpriseScore = item.score;
          });
        this.formatSpan();
        this.show = true;
      } else this.$message.error(res.msg);
    },
    formatSpan() {
      this.idArr = [];
      this.idPos = 0;
      this.scoreItemList.forEach((item, i) => {
        if (i == 0) {
          // 第一行显示
          this.idArr.push(1);
          this.idPos = 0;
        } else {
          if (
            this.scoreItemList[i].postId == this.scoreItemList[i - 1].postId
          ) {
            // 相同则合并行数自加
            this.idArr[this.idPos] += 1;
            // 下一行不显示
            this.idArr.push(0);
          } else {
            // 不同则显示
            this.idArr.push(1);
            this.idPos = i;
          }
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.idArr[rowIndex];
        // 判断当前的 列是否需要显示
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    handleSubmit() {
      let params = {
        classChapterId: this.$route.query.classChapterId,
        teamId: this.teamId,
        itemScoreList: this.scoreItemList,
      };
      this.$confirm("确定要评分吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          giveGrade(params).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("评分成功");
              this.getList();
              this.show = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleSettlement() {
      if (this.scoreRate != 100) {
        this.$message.warning("三项占比加起来必须等于100");
        return;
      }

      this.$confirm("确定要结算成绩吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.saveWeight();
          this.$loading.show();
          setGrade(this.params).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.getList();
              this.$message.success("成绩已结算");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .list {
  .is-leaf {
    color: #fff;
    background-color: #f56c6c;
  }
}
.content {
  .top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    span {
      font-weight: bold;
    }
  }
}
</style>